// Optimizely SDK keys for staging and production
import environment from '@square/environment-utils/environment';
const SQUARE_WEB_PROJECTS_SDK_KEY_PRODUCTION = 'GgFmZYBUQSpoEuttY69TDr';
const SQUARE_WEB_PROJECTS_SDK_KEY_SANDBOX = 'CpzxWU3dxHd8AgLaqq2Ghy';
const SQUARE_WEB_PROJECTS_SDK_KEY_STAGING = 'n5kgMaesMCZADMoNCpdUi';
function getOptimizelySdkKey() {
  if (environment().isProduction) {
    return SQUARE_WEB_PROJECTS_SDK_KEY_PRODUCTION;
  } else if (environment().isSandbox) {
    return SQUARE_WEB_PROJECTS_SDK_KEY_SANDBOX;
  } else {
    return SQUARE_WEB_PROJECTS_SDK_KEY_STAGING;
  }
}
export const SQUARE_WEB_PROJECTS_ID = '16952400626';
export const SQUARE_WEB_PROJECTS_SDK_KEY = getOptimizelySdkKey();